<template>
  <div class="modal-conatiner" :style="[!runIt ? { backgroundImage: `url(${blue_blue})` } : '']">

    <div class="weather-addon" :style="{ backgroundImage: `url(${clouldSun})` }">

    </div>

    <div class="logo-col" v-if="!runIt">
      <!-- <div class="logo center-align"><img style="margin-top: 8px;" width="102px" :src="sldb_logo" alt=""></div>
        <div class="logo center-align"><img width="112px" :src="dvrp_logo" alt=""></div>
        <div class="logo center-align"><img style="margin-top: 8px;" width="160px" :src="wb_logo" alt=""></div>
        <div class="logo center-align"><img style="margin-top: 8px;" width="51px" :src="eu_logo" alt=""></div> -->
      <img :src="logo_strip" alt="">
    </div>
    <div class="desktop-arrows" v-if="runIt">
      <button class="btn-floating btn-small white left" @click="sliderInstance.prev()">
        <i class="material-icons grey-text text-darken-3">arrow_back</i>
      </button>

      <button class="btn-floating btn-small white right" @click="sliderInstance.next()">
        <i class="material-icons grey-text text-darken-3">arrow_forward</i>
      </button>
      <div class="clear"></div>
    </div>
    <div class="slider-group">

      <div class="app-logo" v-if="!runIt">
        <div class="sldb-logo">
          <img :src="sldb_logo" alt="">
        </div>
        <img :src="appLogo" width="100%">
      </div>
      <div v-if="!runIt" class="new-intro">
        <div class="new-title">
          Welcome to the SLDB <em>Act to Adapt</em> Competition and <em>Act to Adapt</em> Climate Change Home Risk
          Assessment App!
        </div>

        <div class="center">
          <button @click="$_startIt()" class="btn z-depth-0 lets-go amber accent-2 grey-text text-darken-4 btn-rounded">
            Click to Begin
          </button>
        </div>

      </div>
      <div class="carousel carousel-slider" ref="carousel" v-if="runIt">
        <transition-group>
          <div class="slider-item carousel-item" :data-id="i" :data-target="i" v-for="(slide, i) in slides" :key="i">

            <!-- <div class="step-count">

              </div> -->
            <div class="modal-title " v-html="slide.title"></div>
            <div class="modal-details" v-html="slide.content"></div>

            <div class="button" v-if="slide.button">
              <router-link :to="{ path: '/' }" class="btn amber grey-text text-darken-3 z-depth-0 btn-rounded"
                v-if="isLogin">
                <i class="material-icons-outlined left">home</i> Return to Home
              </router-link>
              <component v-else :is="slide.button.type" @click="slide.button.action" :tag="slide.button.tag"
                v-bind:to="slide.button.type === 'router-link' ? slide.button.route : false" :class="slide.button.class"
                v-html="slide.button.text"> </component>

            </div>

          </div>
        </transition-group>

      </div>
      <div class="character-container" v-if="runIt">
        <transition name="fade">
          <div class="char_image" v-if="runIt && slides[activeIndex] && slides[activeIndex].image">
            <img :src="slides[activeIndex ? activeIndex : 0].image" alt="">
          </div>
        </transition>
      </div>
    </div>
    <ul class="slider-indicators" v-if="runIt">
      <li class="timed-slide" v-for="(ind, i) in slides" :key="i"
        :style="`width:calc(${100 / slides.length}% - 4px); margin: 0 4px;`" @click="sliderInstance.set(i)">
        <div class="progress">
          <!--   `${100 / ind.duration * timeNow}%` -->
          <div class="determinate" :style="[{
            width: activeIndex < i
              ? `0%`
              : activeIndex === i && !done
                ? `${100 / ind.duration * timeNow}%`
                : activeIndex > i || activeIndex === i && done
                  ? '100%'
                  : done
                    ? '100%'
                    : `100%`
          }]"></div>
        </div>
      </li>
    </ul>
    <div class="slider-navigation z-depth-1" v-if="runIt">
      <router-link tag="button" :to="{ name: 'Home' }" v-if="activeIndex === 0 && runIt"
        class="btn btn-rounded z-depth-0 grey-text text-darken-3 waves-effect white left">SKIP</router-link>
      <button @click="sliderInstance.prev()" v-else-if="runIt"
        class="btn btn-rounded z-depth-0 grey-text text-darken-3 waves-effect white left">BACK</button>

      <button v-if="runIt && activeIndex !== (slides.length - 1)" @click="sliderInstance.next()"
        class="btn btn-rounded amber amber-darken-2 grey-text text-darken-3 right ">NEXT</button>
      <!-- <router-link v-else-if="activeIndex > 0" tag="button" :to="{ name: 'Home' }"
        class="btn btn-rounded amber amber-darken-2 grey-text text-darken-3 right">BEGIN</router-link> -->

      <div class="clear"></div>
    </div>

  </div>
</template>
<script>

import appLogo from '@/assets/act_to_adapt@2x.png'
import sldb_logo from '@/assets/sldb_logo.png'
import clouldSun from '@/assets/cloudSun.svg'

import caff_badge from '@/assets/act_intro.png'
import blue_blue from '@/assets/new_color_pngs@2x.png'
import logo_strip from '@/assets/logo_strip@2x.png'
export default {
  name: 'welcomeModal',
  props: {
    dataSlides: {
      type: [Array, Boolean]
    },
    modalState: {
      type: String,
      default: 'close'
    },
  },
  data() {
    return {
      runIt: false,
      ready: false,
      appLogo,
      logo_strip,
      sldb_logo,
      clouldSun,
      blue_blue,
      caff_badge,
      slideLength: null,
      timeNow: 0,
      done: false,
      playing: false,
      isPlaying: false,
      isLast: false,
      intervalInstance: null,

      sliderInstance: null,
      slider_options: {
        fullWidth: true,
        indicators: false,
        onCycleTo: (e) => {
          let indexVal = parseInt(e.attributes['data-target'].value)
          /*         this.$emit('currentIndex', e.attributes['data-target'].value) */
          //  this.activeIndex = -1
          this.activeIndex = indexVal
          if (indexVal < 1) {
            this.done = false
          }
          this.timeNow = 0
          // this.activeIndex = parseInt(e.attributes['data-id'].value)
        }
      },
      activeIndex: 0,
      modal: {
        instance: null,
        options: {
          dismissible: false,
          onOpenEnd: () => {
            this.ready = true
            if (this.runIt) this.$_initSlider()
          },
          onCloseStart: () => {
            setTimeout(() => {
              this.$emit('setState', 'closed')
            }, 300);

          },
          onCloseStart: () => {
            setTimeout(() => {
              this.sliderInstance.destroy()
              this.modal.instance.destroy()
              this.sliderInstance = null
              this.modal.instance = null
            }, 150);
          }
        }
      }
    }
  },
  mounted() {
    /*  this.modal.instance = M.Modal.init(this.$refs.modal, this.modal.options)
     setTimeout(() => {
       this.modal.instance.open()
     }, 150) */
    this.$route.query && this.$route.query.start ? setTimeout(() => { this.$_startIt() }, 1400) : ''
  },
  beforeDestroy() {
    ///this.modal.instance.close()
  },
  watch: {
    modalState: function (nV) {
      /*  if(nV === 'open') {
         this.modal.instance = M.Modal.init(this.$refs.modal, this.modal.options)
         setTimeout(() => {
           this.modal.instance.open()
         }, 150);
       }
       else if (nV === 'closed') {
        if ( this.modal.instance !== null ) {
         this.modal.instance.close()
        }
        if ( this.sliderInstance !== null ) {
          console.log('destroying')
         this.sliderInstance.destroy()
        }

       } */
    },
    done: function (nV) {
      if (!nV) {
        this.$_updateTimer()
      }
    },
    timeNow: function (nV) {
      if (nV.toFixed(0) === this.activeDuration.toFixed(0)) {
        if (this.activeIndex !== (this.slides.length - 1)) this.sliderInstance.next()
        if (this.activeIndex === this.slides.length - 1) {
          setTimeout(() => {
            this.$_clearTimeout()
            this.done = true
            this.timeNow = 0
          }, (this.activeDuration * 100) - 2);
        }
      }

    }
  },
  computed: {
    isLogin() {
      return this.$store.state.User.isLogin;
    },
    slides: {
      get() {
        return this.dataSlides
      }
    },
    activeDuration: {
      get() {
        return this.slides[this.activeIndex] ? this.slides[this.activeIndex].duration : 0
      }
    }
  },
  methods: {
    $_startIt() {
      this.runIt = true
      setTimeout(() => {
        this.$_initSlider()
      }, 100);
    },
    /**
     * Counting Clock
     */
    $_updateTimer() {
      /* return  */
      this.intervalInstance = setInterval(() => { this.timeNow += 0.100 }, 100)
    },
    $_clearTimeout() {
      clearInterval(this.intervalInstance)
      this.intervalInstance = null
    },
    $_initSlider() {

      this.sliderInstance = M.Carousel.init(
        this.$refs.carousel,
        this.slider_options
      )

      setTimeout(() => {
        // this.$_updateTimer()
      }, 400);
    }
  }
}
</script>
<style scoped lang="scss">
.modal-conatiner {
  height: calc(100% - 56px);
  width: 100%;
  background-repeat: no-repeat;
  background-size: 0% 0%;

  @media screen and (max-width: 689px) {
    background-size: 100%;
    background-position: 3vw 75vh;
  }

  @media screen and (min-width: 1024px) {
    .modal-content {
      padding: 46px;
    }
  }

  .slider-group {
    position: absolute;
    width: 100%;
    height: calc(100% - 126px);
  }

  .carousel {
    width: 100%;
    position: absolute;
    top: 60%;
    height: 100% !important;
    transform: translate(-50%, -50%);
    max-width: 550px;
    left: 50%;
    z-index: 8;

    @media screen and (max-width:330px) {
      top: 50%;
    }

    @media screen and (max-height:590px) {
      top: 50%;
    }

    @media screen and (min-height:900px) {
      top: 70%;
    }

    .carousel-item {
      padding: 16px 24px;

    }

    /*
      .carousel-slider {
        padding: 24px;
      } */
  }

  .modal-title {
    font-size: 24px;
    color: #8A4FB5;
    margin-bottom: 12px;
    line-height: 1.2;

    @media screen and (min-width:690px) {
      font-size: 32px;
      margin-bottom: 20px;
    }
  }

  .modal-details {
    font-size: 16px;
    line-height: 1.6;

    @media screen and (max-width:690px) {
      font-size: 15px;
      line-height: 1.6;
    }
  }

  .slider-navigation {
    position: fixed;
    background: white;
    bottom: 0;
    padding: 16px;
    z-index: 12;
    left: 0;
    right: 0;
  }

  .step-count {
    /*    background: #ffc107; */
    display: inline-block;
    width: 36px;
    height: 36px;
    /*     text-align: center;
    line-height: 36px;
    border-radius: 4px;
    font-size: 18px; */
    margin-bottom: 14px;
    /*     position: relative;
    color: #536dfe;
    font-weight: 600; */
    /*    &::before {
      content: ' ';
      position: absolute;
      left: 0px;
      top: 0px;
      background: white;
      width: 100%;
      height: 100%;
      z-index: -1;
      transform: rotate(-8deg);
      border-radius: 5px;
    } */
  }
}

.slider-indicators {
  position: absolute;
  display: flex;
}

.app-logo {
  padding: 58px 24px 24px;
  text-align: center;
  max-width: 300px;
  margin: auto;
  position: relative;

  @media screen and (max-height: 590px) {
    padding: 18px 24px 14px;
  }

  img {
    width: 240px;
  }

}

.sldb-logo {
  width: 106px;
  position: absolute;
  left: 45%;
  transform: translateX(-90%);
  margin-top: 3px;
  min-width: 106px;

  img {
    max-width: 100%;
  }
}

.new-intro {
  padding: 0px 24px 20px;
  max-width: 550px;
  margin: auto;

  .new-title {
    font-size: 16px;
    letter-spacing: .5px;
    margin-bottom: 32px;
    text-align: center;
    width: 90%;
    margin-left: 5%;
    margin-top: 12px;

    @media screen and (max-height: 590px) {
      margin-bottom: 12px;
    }
  }
}

.lets-go {
  min-width: 160px
}

.character-container {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  height: 400px;
  max-width: 550px;
  width: 100%;
  z-index: 0;
}

.char_image {
  position: absolute;
  right: 0;
  bottom: -30px;
  height: 400px;

  img {
    height: 100%;
    width: auto;
  }
}

/*  .weather-addon{
    height: 100px;
    background-size: 100%;
    max-width: 568px;
    background-repeat: no-repeat;
    background-position: 20px 30px;
  } */
</style>
<style lang="scss">
.slider-item {
  &.carousel-item {
    p {
      font-size: 16px !important;
    }

    &[data-id="0"] {
      .modal-title {
        width: calc(100% - 72px);
      }

      ul {
        li:nth-of-type(1) {
          width: calc(100% - 70px);
        }

        li:nth-of-type(2),
        li:nth-of-type(3) {
          width: calc(100% - 100px);
        }
      }
    }

    &[data-id="1"] {
      ul {
        li:nth-of-type(2) {
          width: calc(100% - 150px);
        }
      }
    }

    &[data-id="2"] {
      .modal-details {
        p:nth-of-type(1) {
          width: calc(100% - 145px);
        }

        p:nth-of-type(2) {
          width: calc(100% - 145px);
        }
      }
    }

    &[data-id="3"] {
      .modal-details {
        width: calc(100% - 135px);
      }
    }

    &[data-id="4"] {
      .modal-title {
        width: calc(100% - 20px);
      }

      .modal-details {
        width: calc(100% - 95px);
      }
    }
  }
}

.desktop-arrows {
  top: 45%;
  left: 50%;
  position: absolute;
  width: 100%;
  max-width: 720px;
  z-index: 99;
  transform: translate(-50%, -50%);
  opacity: 0;

  @media screen and (min-width: 768px) {
    opacity: 1;
  }
}

.intro-list {
  /* font-size: 2.2vh; */
  padding-left: 0px !important;

  /* list-style-type: decimal !important; */
  li {
    margin-bottom: 12px;
    /* font-weight: 500; */
    /* list-style-type: decimal !important; */
    position: relative;
    /* padding-left: 5px; */
    font-size: 16px;
    /*   &::marker {
          font-size: 19px;
          line-height: 14px;
      } */
  }
}

.slider-indicators {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
}

.logo-col {
  position: absolute;
  bottom: 24px;
  margin-top: 18px;
  left: 26px;
  right: 26px;
  width: calc(100% - 48px);
  overflow: hidden;
  overflow-x: scroll;
  text-align: center;

}

.button {
  padding-top: 18px;
  /*    text-align: center; */
}
</style>